function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.7896 0.094512C32.8221 -0.188621 33.9773 0.185865 34.3696 0.93095C34.762 1.67603 34.243 2.50957 33.2105 2.7927L18.2105 6.90588C17.7528 7.03137 17.2473 7.03137 16.7896 6.90588L1.78962 2.7927C0.757082 2.50957 0.238122 1.67603 0.630486 0.93095C1.02285 0.185865 2.17796 -0.188621 3.21049 0.094512L17.5001 4.01288L31.7896 0.094512Z",
  fill: "#E7E7E7"
});

var SvgPullUpChevron = function SvgPullUpChevron(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 7,
    viewBox: "0 0 35 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPullUpChevron, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pull-up-chevron.f23f3f3a.svg";
export { ForwardRef as ReactComponent };